import React, { Component } from 'react';


class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: {},
            initialForm: false
        };
    }

    render() {
        const { children } = this.props;

        return (
            <div className="pd-content-top col-sm-12 col-md-12 col-lg-12 text-center header-container no-gutters" >
                <div className="header-img" >
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/auto-facil-logo.png`)} />
                </div>
                <div className="header-message custom-padding-titles">
                    {children && children}
                </div>
            </div>
        );
    }
}

export default Header;


/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/